/**
 * Persistência NÃO sensível da sessão do TurboPro — nunca token, nunca
 * segredo (o access token JWT vive só em memória, ver `@/api/turbopro`).
 *
 * Serve só para: (a) saber, pós-F5, que havia uma sessão e tentar
 * `/Auth/Refresh` antes de montar a rota (`RequireSession`); (b) exibir
 * metadados (email, empresa, cnpj do gestor) sem esperar um round-trip.
 *
 * Único lugar do projeto que lê/grava estas chaves.
 */

const CHAVES = {
  logado: 'tp_logado',
  email: 'tp_email',
  cnpjGestor: 'tp_cnpj_gestor',
  empresa: 'tp_empresa',
} as const;

export interface SessaoTurboPro {
  logado: boolean;
  email: string | null;
  cnpjGestor: string | null;
  empresa: string | null;
}

export function sessao(): SessaoTurboPro {
  return {
    logado: localStorage.getItem(CHAVES.logado) === 'true',
    email: localStorage.getItem(CHAVES.email),
    cnpjGestor: localStorage.getItem(CHAVES.cnpjGestor),
    empresa: localStorage.getItem(CHAVES.empresa),
  };
}

/** Chamado depois de um `/Auth/Login` bem-sucedido. */
export function gravarLogin(email: string): void {
  localStorage.setItem(CHAVES.logado, 'true');
  localStorage.setItem(CHAVES.email, email);
}

/** Chamado depois de um `/Auth/SelecionarGestor` bem-sucedido. */
export function gravarGestor(cnpjGestor: string, empresa?: string): void {
  localStorage.setItem(CHAVES.cnpjGestor, cnpjGestor);
  if (empresa) localStorage.setItem(CHAVES.empresa, empresa);
}

export function limparSessao(): void {
  Object.values(CHAVES).forEach(chave => localStorage.removeItem(chave));
}
